import React, { useEffect } from "react";
import { useState } from "react";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { Logo } from "../components/seechelle/Logo";
import { Lock, Loader2 } from "lucide-react";

const NoIndex = () => {
  useEffect(() => {
    const m = document.createElement("meta");
    m.name = "robots";
    m.content = "noindex, nofollow";
    document.head.appendChild(m);
    return () => { document.head.removeChild(m); };
  }, []);
  return null;
};

export const AdminLogin = () => {
  const { user, loading, login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!loading && user) {
    return <Navigate to={loc.state?.from?.pathname || "/admin"} replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const r = await login(email, password);
    setSubmitting(false);
    if (r.ok) nav(loc.state?.from?.pathname || "/admin");
    else setError(r.error);
  };

  return (
    <div className="min-h-screen bg-blush-50 flex items-center justify-center px-6">
      <NoIndex />
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <Logo size="md" />
        </div>
        <div className="bg-white rounded-2xl border border-blush-200/70 shadow-[0_25px_60px_-30px_rgba(180,43,106,0.25)] p-8 md:p-10">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-blush-100 mb-4">
              <Lock className="text-magenta" size={18} />
            </div>
            <h1 className="font-serif text-3xl text-ink">Admin sign in</h1>
            <p className="sc-body mt-2">Manage your website content.</p>
          </div>

          <form onSubmit={onSubmit} className="space-y-6" data-testid="admin-login-form">
            <div>
              <label htmlFor="admin-email" className="sc-label">Email</label>
              <input id="admin-email" type="email" required autoComplete="email"
                     className="sc-input" value={email} onChange={(e) => setEmail(e.target.value)}
                     data-testid="admin-email-input" />
            </div>
            <div>
              <label htmlFor="admin-password" className="sc-label">Password</label>
              <input id="admin-password" type="password" required autoComplete="current-password"
                     className="sc-input" value={password} onChange={(e) => setPassword(e.target.value)}
                     data-testid="admin-password-input" />
            </div>
            {error && <p className="text-magenta text-sm" data-testid="admin-login-error">{error}</p>}
            <button type="submit" disabled={submitting}
                    className="sc-btn-primary w-full justify-center disabled:opacity-70 disabled:cursor-not-allowed"
                    data-testid="admin-login-btn">
              {submitting ? (<><Loader2 size={16} className="animate-spin" />Signing in…</>) : "Sign in"}
            </button>
          </form>
        </div>
        <p className="text-center text-[12px] text-muteink mt-6 font-body">
          Not authorised? <a href="/" className="sc-link">Go back to the website.</a>
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
